import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import {
  selectNotificationState,
  updateNotificationState,
} from '../../modules/notifications.js';

const mapStateToProps = (state) => ({
  notificationState: selectNotificationState(state),
});

const mapDispatchToProps = { updateNotificationState };

const NotificationContainer = ({
  updateNotificationState,
  notificationState,
}) => {
  const currentPath = window.location.pathname;

  useEffect(() => {
    if (currentPath !== notificationState.forPath) {
      updateNotificationState({
        isShown: false,
        type: 'primary',
        message: '',
        forPath: '',
      });
    }

    if (notificationState && notificationState.isShown) {
      const timer = setTimeout(() => {
        updateNotificationState({
          isShown: false,
          type: 'primary',
          message: '',
          forPath: '',
        });
      }, 7000);

      return () => clearTimeout(timer);
    }
  }, []);

  return (
    <div className="notification-overlay">
      {notificationState && notificationState.isShown ? (
        <div className={`alert ${notificationState.type}`}>
          <p>{notificationState.message}</p>
        </div>
      ) : null}
    </div>
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(NotificationContainer);
